// Eldhose John 20240114 @SumUps.com
import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import Main from './Main';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Main />);
